// extracted by mini-css-extract-plugin
module.exports = {"textWithPhotoEffectWrap":"PageTemplate-module--textWithPhotoEffectWrap--2APth","main":"PageTemplate-module--main--1q84V","formWrap":"PageTemplate-module--formWrap--w27gw"};